<template>
  <div class="top">
    <div>
      <router-link :to="{path: '/'}">
        <img src="@/assets/img/log.png" alt>
      </router-link>
      <p>{{webUrl}}</p>
    </div>
    <div>
      <input v-model="keyword" type="text" placeholder="请输入搜索内容">
      <div class="search_btn" @click="searchInfoFn(keyword)">搜索</div>
      <div v-if="btnShow" class="fabu_btn" @click="fabuMarket">我要发布</div>
    </div>
  </div>
</template>

<script>
import { getRuzhuinfo } from '@/axios/userEducation'
import sign from '@/auth/sign'
export default {
  data () {
    return {
      btnShow: true,
      webUrl: '',
      keyword: ''
    }
  },
  computed: {
    oneType () {
      return this.$store.getters.oneType
    }
  },
  mounted () {
    if (this.oneType && this.oneType.length) {
      for (let i = 0; i < this.oneType.length; i++) {
        if (this.oneType[i].menu_en === 'education') {
          this.webUrl = this.oneType[i].url
        }
      }
    }
  },
  created () {
    this.companyLeixing(1)
  },
  methods: {
    searchInfoFn (keyword) {
      if (keyword) {
        this.$router.push({name: 'Search', query: { keyword }})
      } else {
        this.$message.error('请先输入搜索内容！')
      }
    },
    fabuMarket () {
      this.companyLeixing(2)
    },
    companyLeixing (type) {
      let oneParams = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000)
      }
      let signO = sign(oneParams)
      oneParams.sign = signO
      getRuzhuinfo(oneParams).then(res => {
        if (type === 1) {
          if (res.data.code === 200 && res.data.data.desc !== '普通用户') {
            this.btnShow = false
          }
        } else {
          if (res.data.code === 101) {
            this.$router.push({
              name: 'Login'
            })
          }
          if (res.data.data.desc === '普通用户') {
            this.$router.push({
              name: 'ReleaseEducation'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.top {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0;
  overflow: hidden;
}
.top > div:first-child {
  float: left;
}
.top > div:first-child a {
  height: 65px;
  float: left;
}
.top > div:first-child p{
  float: left;
  margin-left: 5px;
  margin-top: 33px;
  font-size: 18px;
  color: #888;
}
.top > div:last-child {
  float: right;
  height: 72px;
  position: relative;
  padding-top: 16px;
  box-sizing: border-box;
}
.top > div:last-child input {
  width: 450px;
  height: 18px;
  padding: 10px 10px 8px 12px;
  border: 2px solid #ff971b;
  line-height: 18px;
  border-radius: 3px 0 0 3px;
  float: left;
}
.search_btn {
  display: inline-block;
  width: 100px;
  height: 40px;
  color: #fff;
  overflow: hidden;
  cursor: pointer;
  font-size: 20px;
  letter-spacing: 1px;
  text-align: center;
  background-color: #ff971b;
  border-radius: 0 3px 3px 0;
}
.fabu_btn{
  width: 120px;
  text-align: center;
  height: 42px;
  line-height: 42px;
  background: #1da03d;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  float: right;
  margin-left: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/education/Top.vue